import { useState } from "react";
import styles from "./TestimonialForm.module.scss";
import { useFormik } from "formik";
import validationSchema from "../../models/TestimonialSchema";
import InputCustom from "../InputCustom/InputCustom";
import TextareaCustom from "../../components/TextareaCustom/TextareaCustom";
import Button from "../../components/Button/Button";
import { sendTestimonial } from "../../api/testimonial";

function TestimonialForm({ onClose, onSubmitSuccess }) {
  const [serverErrors, setServerErrors] = useState({});

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      testimonialText: "",
    },
    validationSchema,
    onSubmit: async (formValues, { setSubmitting }) => {
      setServerErrors({});
      setSubmitting(true);

      try {
        const response = await sendTestimonial(formValues);

        if (response.status === 201) {
          onSubmitSuccess();
          formik.resetForm();
          onClose();
        }
      } catch (error) {
        const data = error.response?.data;

        if (data?.errors && typeof data.errors === "object") {
          setServerErrors(data.errors);
        }
        // Optionnel : tu peux aussi gérer data.message globalement (toast, etc.)
      } finally {
        setSubmitting(false);
      }
    },
  });

  const renderFieldError = (fieldName) => {
    const formikError = formik.touched[fieldName] && formik.errors[fieldName];
    const serverError = serverErrors[fieldName];

    if (formikError) {
      return <div className={styles.error}>{formikError}</div>;
    }
    if (serverError) {
      return <div className={styles.error}>{serverError}</div>;
    }
    return null;
  };

  return (
    <div className={styles.container}>
      <h2 className="mb-20">Ajouter un avis</h2>
      <form onSubmit={formik.handleSubmit} noValidate>
        <div className="mb-10">
          <InputCustom
            id="lastName"
            type="text"
            name="lastName"
            placeholder="Nom *"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.lastName}
          />
          {renderFieldError("lastName")}
        </div>

        <div className="mb-10">
          <InputCustom
            id="firstName"
            type="text"
            name="firstName"
            placeholder="Prénom *"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.firstName}
            style={{ marginTop: "10px" }}
          />
          {renderFieldError("firstName")}
        </div>

        <div className="mb-5">
          <InputCustom
            id="email"
            type="email"
            name="email"
            placeholder="Email *"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            style={{ marginTop: "10px" }}
          />
          {renderFieldError("email")}
        </div>

        <div>
          <TextareaCustom
            id="testimonialText"
            name="testimonialText"
            placeholder="Rédigez votre avis *"
            rows="10"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.testimonialText}
          />
          {renderFieldError("testimonialText")}
        </div>

        <div className={styles.btnContainer}>
          <Button
            disabled={formik.isSubmitting}
            type="submit"
            style={{
              margin: "30px auto",
              marginBottom: "0",
            }}
            color="var(--secondary-color)"
          >
            {formik.isSubmitting ? "Veuillez patienter ..." : "Envoyer"}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default TestimonialForm;
